import React from 'react';
import PropTypes from 'prop-types';
import useProfileImage from 'Hooks/useProfileImage';

const ProfileImageContext = React.createContext(undefined);

function ProfileImageProvider({
  children,
  profileImageLink,
}) {
  const { profileImage, fetchProfileImage } = useProfileImage({
    avatarLink: profileImageLink,
  });

  React.useEffect(() => {
    fetchProfileImage();
  }, []);

  return (
    <ProfileImageContext.Provider value={profileImage}>
      {children}
    </ProfileImageContext.Provider>
  );
}

function useProfileImageContext() {
  const context = React.useContext(ProfileImageContext);

  if (context === undefined) {
    throw new Error('useProfileImageContext must be used within a ProfileImageProvider');
  }

  return context;
}

ProfileImageProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  profileImageLink: PropTypes.object.isRequired,
};

export {
  ProfileImageProvider,
  useProfileImageContext,
};
